var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filterInputFacet"},[_c('SaiInput',{staticClass:"sai-input",attrs:{"value":_vm.getSearchResultsFilterValue(_vm.field),"placeholder":_vm.placeholder,"type":"text","name":_vm.name},on:{"input":_vm.handleInputChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }